module.exports = __webpack_public_path__ + "img/add.3a42ee90.svg";